<template>
  <div id="progress" class="progress" :class="{ 'no-join': canJoin }">
    <div
      v-for="(item, index) in progressList"
      :key="index"
      class="step"
      :class="{ completed: item.completeStatus }"
    >
      <div v-if="index === 0" class="round-left">
        <div class="date">
          {{ item.value + item.unit }}
        </div>
      </div>
      <template v-else-if="index === progressList.length - 1">
        <div class="line"></div>
        <div class="roune-end">
          <div class="value">
            {{ `¥ ${stageMoney}` }}
          </div>
          <div class="date">
            {{ item.value + item.unit }}
          </div>
        </div>
      </template>
      <template v-else>
        <div class="line"></div>
        <div class="round">
          <div class="date">
            {{ item.value + item.unit }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Progress',
  props: {
    progressList: {
      type: Array,
      default: () => []
    },
    stageMoney: {
      type: Number,
      default: 0
    },
    canJoin: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
.step {
  display: inline-block;

  position: relative;

  width: 1.35rem;
  height: 0.4rem;

  font-size: 0;
  &:first-of-type {
    width: 0;
  }
  .round,
  .round-left {
    position: absolute;
    top: 0;
    z-index: 1;

    width: 0.4rem;
    height: 0.4rem;

    background-image: url('../images/weiwancheng.png');
    background-repeat: no-repeat;
    border-radius: 50%;
    background-size: 100% 100%;
  }
  .line {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 0.74rem;
    height: 1px;

    background-color: #ffd5aa;
  }
  .round {
    right: -0.2rem;
  }
  .round-left {
    left: -0.2rem;
  }
  &.completed {
    .round,
    .round-left {
      background-image: url('../images/wancheng.png');
    }
    .line {
      background-color: #ffd5aa;
    }
  }

  .date {
    position: absolute;
    bottom: -0.48rem;
    left: 50%;
    transform: translateX(-50%);

    font-size: 0.24rem;
    line-height: 0.24rem;
    color: #333;
  }
  .roune-end {
    position: absolute;
    top: -0.38rem;
    right: -0.6rem;

    width: 0.8rem;
    height: 0.78rem;

    background-image: url('../images/jinbi.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .value {
      width: 0.8rem;
      height: 0.3rem;
      margin-top: 0.48rem;

      font-size: 0.24rem;
      line-height: 0.32rem;
      text-align: center;
      color: #fff;
    }
  }
}
.progress {
  padding: 0.48rem 1rem 0 0.72rem;

  white-space: nowrap;
  &.no-join {
    .step {
      .line {
        background-color: #cbcbcb;
      }
      .round,
      .round-left {
        background-image: url('../images/weiwancheng-zhihui.png');
      }
      &.completed {
        .round,
        .round-left {
          background-image: url('../images/wancheng-zhihui.png');
        }
        .line {
          background-color: #cbcbcb;
        }
      }

      .roune-end {
        background-image: url('../images/jinbi-zhihui.png');
      }
    }
  }
}
</style>
